// document.addEventListener("DOMContentLoaded", function () {
//   document.body.addEventListener("click", function (event) {
//     if (event.target.id === "ProductSubmitButton-quickadd-template--17832055963821__main" || 
//         event.target.closest("#ProductSubmitButton-quickadd-template--17832055963821__main")) {
//       setTimeout(function () {
//         window.scrollTo(0, 0);
//         window.location.reload();
//       }, 5000);
//     }
//   });
// });
// document.addEventListener("DOMContentLoaded", function () {
//   document.body.addEventListener("click", function (event) {
//     if (event.target.id === "ProductSubmitButton-quickadd-template--17832055931053__main" || 
//         event.target.closest("#ProductSubmitButton-quickadd-template--17832055931053__main")) {
//       setTimeout(function () {
//         window.scrollTo(0, 0);
//         window.location.reload();
//       }, 5000);
//     }
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  let reloadTriggered = false;

  function triggerReloadOnce() {
    if (!reloadTriggered) {
      reloadTriggered = true;
      location.reload();
    }
  }

  document.body.addEventListener("click", function (event) {
    const addToCartBtn = event.target.closest("button[name='add']");
    const isInQuickAdd = addToCartBtn?.closest(".quick-add-modal");

    if (addToCartBtn && isInQuickAdd) {
      const handleCartChange = () => {
        document.removeEventListener("shopify:section:load", handleCartChange);
        triggerReloadOnce();
      };

      document.addEventListener("shopify:section:load", handleCartChange);

      const observer = new MutationObserver(() => {
        triggerReloadOnce();
        observer.disconnect();
      });

      observer.observe(document.body, { childList: true, subtree: true });

      setTimeout(triggerReloadOnce, 3000);
    }
  });
});

// Track the currently opened product ID and variant ID
let currentProductId = null;
let currentVariantId = null;

if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      // Get the product ID from the opener
      const productUrl = opener.getAttribute('data-product-url');
      const productIdMatch = productUrl.match(/products\/([^\/]+)/);
      if (productIdMatch) {
        currentProductId = productIdMatch[1];
      }

      fetch(productUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          // Initialize both addons and extra addons
          initializeAddons();
          initializeExtraAddons();
          initializeSlider();

          // Get the selected variant ID
          const variantInput = this.modalContent.querySelector('[name="id"]');
          if (variantInput) {
            currentVariantId = variantInput.value;
            console.log('Selected Variant ID:', currentVariantId); // Debug
          }

          // Listen for variant changes
          const variantPicker = this.modalContent.querySelector('variant-selects, variant-radios');
          if (variantPicker) {
            variantPicker.addEventListener('change', (e) => {
              currentVariantId = e.detail.variant.id;
              console.log('Variant Changed:', currentVariantId); // Debug
            });
          }

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialog) modalDialog.forEach(modal => modal.remove());
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
        element.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }
  });
}

function initializeSlider() {
  const slider = document.querySelector('.addon-slider');
  const prevButton = document.querySelector('.slider-prev');
  const nextButton = document.querySelector('.slider-next');
  
  if (!slider || !prevButton || !nextButton) return;

  const sliderState = {
    currentIndex: 0,
    cardWidth: 0,
    margin: 10,
    isDragging: false,
    startPosX: 0,
    currentTranslate: 0,
    prevTranslate: 0,
    animationID: null
  };

  function calculateCardsPerView() {
    const containerWidth = document.querySelector('.addon-slider-container').offsetWidth;
    const card = slider.querySelector('.addon-product-card');
    if (!card) return;
    
    const cardsPerView = 3; 
    const totalMargin = sliderState.margin * (cardsPerView - 1);
    sliderState.cardWidth = (containerWidth - totalMargin) / cardsPerView;
    
    document.querySelectorAll('.addon-product-card').forEach(card => {
      card.style.width = `${sliderState.cardWidth}px`;
      card.style.marginRight = `${sliderState.margin}px`;
      card.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    });
    
    slider.style.width = `calc(${sliderState.cardWidth * slider.children.length}px + ${sliderState.margin * (slider.children.length - 1)}px)`;
  }

  function updateSlider() {
    const slideAmount = (sliderState.cardWidth + sliderState.margin) * sliderState.currentIndex;
    const containerWidth = document.querySelector('.addon-slider-container').offsetWidth;
    const maxTranslate = slider.scrollWidth - containerWidth;
    
    sliderState.currentIndex = Math.min(sliderState.currentIndex, Math.ceil(maxTranslate / (sliderState.cardWidth + sliderState.margin)));
    slider.style.transform = `translateX(-${Math.min(slideAmount, maxTranslate)}px)`;
    
    const activeDotIndex = Math.floor(sliderState.currentIndex / 2);
    document.querySelectorAll('.slider-dot').forEach((dot, index) => {
      dot.classList.toggle('active', index === activeDotIndex);
    });
  }

  calculateCardsPerView();
  updateSlider();

  prevButton.addEventListener('click', (e) => {
    e.preventDefault();
    const step = 2; 
    sliderState.currentIndex = Math.max(sliderState.currentIndex - step, 0);
    updateSlider();
  });

  nextButton.addEventListener('click', (e) => {
    e.preventDefault();
    const step = 2;
    const cardsPerView = 3;
    const maxIndex = slider.children.length - cardsPerView;
    sliderState.currentIndex = Math.min(sliderState.currentIndex + step, maxIndex);
    updateSlider();
  });

  function createDots() {
    const cardsPerSlide = 2;
    const cardsPerView = 3;
    const totalDots = Math.ceil((slider.children.length - cardsPerView) / cardsPerSlide) + 1;
    
    dotsContainer.innerHTML = '';
    
    for (let i = 0; i < totalDots; i++) {
      const dot = document.createElement('button');
      dot.className = 'slider-dot' + (i === 0 ? ' active' : '');
      dot.addEventListener('click', () => {
        sliderState.currentIndex = i * cardsPerSlide;
        updateSlider();
      });
      dotsContainer.appendChild(dot);
    }
  }

  const dotsContainer = document.createElement('div');
  dotsContainer.className = 'slider-dots';
  document.querySelector('.addon-slider-container').appendChild(dotsContainer);
  createDots();

  const resizeObserver = new ResizeObserver(entries => {
    calculateCardsPerView();
    createDots();
    updateSlider();
  });

  resizeObserver.observe(document.querySelector('.addon-slider-container'));

  window.addEventListener('resize', () => {
    calculateCardsPerView();
    createDots();
    updateSlider();
  });

  const quantityInputs = document.querySelectorAll('.addon-quantity .quantity__input');
  quantityInputs.forEach(input => {
    const minusButton = input.previousElementSibling;
    const plusButton = input.nextElementSibling;

    minusButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      input.value = Math.max(1, input.value - 1);
      updateAddonQuantity(input);
    });

    plusButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      input.value = parseInt(input.value) + 1;
      updateAddonQuantity(input);
    });

    input.addEventListener('change', function() {
      this.value = Math.max(1, this.value);
      updateAddonQuantity(this);
    });
  });

  const productCards = document.querySelectorAll('.addon-product-card');
  productCards.forEach(card => {
    const checkbox = card.querySelector('.addon-checkbox');
    const selectButton = card.querySelector('.select-button');
    const minusButton = card.querySelector('.quantity__button[name="minus"]');
    const plusButton = card.querySelector('.quantity__button[name="plus"]');
    const quantityInput = card.querySelector('.quantity__input');

    selectButton.addEventListener('click', (e) => {
      e.stopPropagation(); 
      checkbox.checked = !checkbox.checked;
      checkbox.dispatchEvent(new Event('change'));
      updateAddonQuantity(quantityInput); 
      if (checkbox.checked) {
        selectButton.style.display = 'none';
        minusButton.style.display = 'inline-block';
        plusButton.style.display = 'inline-block';
        quantityInput.style.display = 'inline-block';
      } else {
        selectButton.style.display = 'inline-block';
        minusButton.style.display = 'none';
        plusButton.style.display = 'none';
        quantityInput.style.display = 'none';
      }
    });
    card.addEventListener('click', (e) => {
      if (e.target.closest('.addon-quantity')) return;
      selectButton.click(); 
    });
  });
  const checkboxes = document.querySelectorAll('.addon-checkbox');
  checkboxes.forEach(checkbox => {
    const checkmark = checkbox.nextElementSibling?.querySelector('.checkmark');
    const quantityInput = checkbox.closest('.addon-product-card')?.querySelector('.quantity__input');
    
    checkbox.addEventListener('change', function() {
      if (checkmark) {
        checkmark.classList.toggle('checked', this.checked);
      }
      const addonId = this.dataset.addonId;
      const quantity = parseInt(quantityInput?.value || 1);
      toggleMainAddon(addonId, this.checked ? quantity : 0);
    });
  });
  function updateAddonQuantity(input) {
    const checkbox = input.closest('.addon-product-card').querySelector('.addon-checkbox');
    if (checkbox?.checked) {
      const addonId = checkbox.dataset.addonId;
      toggleMainAddon(addonId, parseInt(input.value));
    }
  }

  function toggleMainAddon(addonId, quantity = 1) {
    const index = window.selectedAddons.findIndex(item => item.id === addonId);
    if (index > -1) {
      if (quantity > 0) {
        window.selectedAddons[index].quantity = quantity;
      } else {
        window.selectedAddons.splice(index, 1);
      }
    } else if (quantity > 0) {
      window.selectedAddons.push({ 
        id: addonId, 
        quantity: quantity,
        properties: {
          '_is_addon': 'true',
          '_source_product': '{{ product.id }}'
        }
      });
    }
    console.log('Main Addons:', window.selectedAddons); // Debug
  }
  window.selectedAddons = [];
  window.selectedExtraAddons = [];

  const addToCartButton = document.getElementById('ProductSubmitButton-quickadd-template--17832055963821__main');

  if (addToCartButton) {
    addToCartButton.addEventListener('click', async function(e) {
      e.preventDefault();
      
      try {
        // Disable button and show loading spinner
        this.disabled = true;
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        // Use the current variant ID
        if (!currentVariantId) {
          console.error('Variant ID not found');
          alert('Please select a variant');
          return;
        }
        
        // Prepare the items array with the main product
        const items = [{
          id: currentVariantId,
          quantity: parseInt(document.querySelector('[name="quantity"]')?.value || 1),
          properties: {
            '_source_product': currentProductId
          }
        }];
        
        // Collect selected addons (if any)
        const allAddons = [...(window.selectedAddons || []), ...(window.selectedExtraAddons || [])];
        
        // Add addons to items array if they exist
        if (allAddons.length > 0) {
          const batchSize = 10; // Process 10 addons at a time
          for (let i = 0; i < allAddons.length; i += batchSize) {
            const batch = allAddons.slice(i, i + batchSize);
            
            // Add batch items to cart
            for (const addon of batch) {
              if (addon.id && addon.quantity > 0) {
                items.push({
                  id: addon.id.toString(),
                  quantity: parseInt(addon.quantity),
                  properties: {
                    ...(addon.properties || {}),
                    '_is_addon': 'true',
                    '_source_product': currentProductId
                  }
                });
              }
            }
          }
        }

        // Send items to cart (either just the main product or with addons)
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: items })
        });
        
        if (!response.ok) {
          const error = await response.json();
          console.error('Error adding items to cart:', error);
          throw error;
        }
        
        const data = await response.json();
        console.log('Successfully added items:', data);
        
        // Reload page after items are added
        window.location.reload();
        
      } catch (error) {
        console.error('Error during add to cart:', error);
        if (error.description) {
          alert(error.description);
        } else {
          alert('Failed to add items to cart');
        }
      } finally {
        // Re-enable button and hide loading spinner
        this.disabled = false;
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      }
    });
  }

  let isDragging = false;
  let startPosX = 0;
  let currentTranslate = 0;
  let prevTranslate = 0;
  let animationID;

  if (window.innerWidth < 768) {
    slider.style.cursor = 'grab';

    slider.addEventListener('touchstart', touchStart);
    slider.addEventListener('touchmove', touchMove);
    slider.addEventListener('touchend', touchEnd);
    slider.addEventListener('touchcancel', touchEnd);
  }

  function touchStart(e) {
    if (window.innerWidth >= 768) return;
    
    isDragging = true;
    startPosX = getPositionX(e);
    prevTranslate = currentTranslate;
    slider.style.transition = 'none';
    slider.style.cursor = 'grabbing';
    cancelAnimationFrame(animationID);
  }

  function touchMove(e) {
    if (!isDragging || window.innerWidth >= 768) return;
    
    const currentPosition = getPositionX(e);
    const diff = currentPosition - startPosX;
    currentTranslate = prevTranslate - diff;
    
    const maxTranslate = slider.scrollWidth - slider.parentElement.offsetWidth;
    currentTranslate = Math.max(0, Math.min(currentTranslate, maxTranslate));
    
    slider.style.transform = `translateX(-${currentTranslate}px)`;
  }

  function touchEnd() {
    if (window.innerWidth >= 768) return;
    
    isDragging = false;
    slider.style.cursor = 'grab';
    slider.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';

    const movedBy = currentTranslate - prevTranslate;
    const velocity = movedBy / 100;
    
    let finalTranslate = currentTranslate + (velocity * 50);
    finalTranslate = Math.max(0, Math.min(finalTranslate, slider.scrollWidth - slider.parentElement.offsetWidth));

    const cardsPerSlide = 2;
    const cardsPerView = 3;
    sliderState.currentIndex = Math.round(finalTranslate / (sliderState.cardWidth + sliderState.margin));
    sliderState.currentIndex = Math.min(sliderState.currentIndex, slider.children.length - cardsPerView);
    
    currentTranslate = sliderState.currentIndex * (sliderState.cardWidth + sliderState.margin);
    slider.style.transform = `translateX(-${currentTranslate}px)`;
    updateSlider();
  }

  function getPositionX(e) {
    return e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
  }

  function updateDots() {
    const dots = document.querySelectorAll('.slider-dot');
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === sliderState.currentIndex);
    });
  }
  
  // Handle model open/close events
  const model = document.querySelector('.product-model');
  if (model) {
    model.addEventListener('show.bs.modal', function () {
      // Reinitialize addons when the model is opened
      initializeAddons();
    });

    model.addEventListener('hidden.bs.modal', function () {
      // Reinitialize addons when the model is closed
      initializeAddons();
    });
  }

  // Initialize addons in main content
  initAddons(document.querySelectorAll('.additional-addon'));

  // Initialize addons in modals
  document.addEventListener('modalOpened', function(event) {
    const modal = event.detail.modal;
    initAddons(modal.querySelectorAll('.additional-addon'));
  });

  function initAddons(addons) {
    addons.forEach(addon => {
      // Your addon initialization code here
      addon.addEventListener('click', function() {
        // Handle addon click
      });
    });
  }

  // Initialize extra addons slider
  const extraSlider = document.querySelector('.extra-addon-slider');
  const extraPrevButton = document.querySelector('.extra-addon-slider-prev');
  const extraNextButton = document.querySelector('.extra-addon-slider-next');
  
  if (extraSlider && extraPrevButton && extraNextButton) {
    let extraCurrentIndex = 0;
    let extraCardWidth;
    const extraMargin = 10;
    let isDragging = false;
    let startPosX = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;

    // Add touch event handlers for mobile
    if (window.innerWidth < 768) {
        extraSlider.style.cursor = 'grab';

        extraSlider.addEventListener('touchstart', touchStart);
        extraSlider.addEventListener('touchmove', touchMove);
        extraSlider.addEventListener('touchend', touchEnd);
        extraSlider.addEventListener('touchcancel', touchEnd);
    }

    function touchStart(e) {
        if (window.innerWidth >= 768) return;
        
        isDragging = true;
        startPosX = getPositionX(e);
        prevTranslate = currentTranslate;
        extraSlider.style.transition = 'none';
        extraSlider.style.cursor = 'grabbing';
    }

    function touchMove(e) {
        if (!isDragging || window.innerWidth >= 768) return;
        
        const currentPosition = getPositionX(e);
        const diff = currentPosition - startPosX;
        currentTranslate = prevTranslate - diff;
        
        const maxTranslate = extraSlider.scrollWidth - extraSlider.parentElement.offsetWidth;
        currentTranslate = Math.max(0, Math.min(currentTranslate, maxTranslate));
        
        extraSlider.style.transform = `translateX(-${currentTranslate}px)`;
    }

    function touchEnd() {
        if (window.innerWidth >= 768) return;
        
        isDragging = false;
        extraSlider.style.cursor = 'grab';
        extraSlider.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';

        const movedBy = currentTranslate - prevTranslate;
        const velocity = movedBy / 100;
        
        let finalTranslate = currentTranslate + (velocity * 50);
        finalTranslate = Math.max(0, Math.min(finalTranslate, extraSlider.scrollWidth - extraSlider.parentElement.offsetWidth));

        const cardsPerSlide = 2;
        const cardsPerView = 3;
        extraCurrentIndex = Math.round(finalTranslate / (extraCardWidth + extraMargin));
        extraCurrentIndex = Math.min(extraCurrentIndex, extraSlider.children.length - cardsPerView);
        
        currentTranslate = extraCurrentIndex * (extraCardWidth + extraMargin);
        extraSlider.style.transform = `translateX(-${currentTranslate}px)`;
        updateExtraSlider();
    }

    function getPositionX(e) {
        return e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    }

    function calculateExtraCardsPerView() {
      const containerWidth = document.querySelector('.extra-addon-slider-container').offsetWidth;
      const card = extraSlider.querySelector('.extra-addon-product-card');
      if (!card) return;
      
      const cardsPerView = 3;
      const totalMargin = (cardsPerView - 1) * extraMargin;
      extraCardWidth = (containerWidth - totalMargin) / cardsPerView;
      
      document.querySelectorAll('.extra-addon-product-card').forEach(card => {
        card.style.width = `${extraCardWidth}px`;
        card.style.marginRight = `${extraMargin}px`;
      });
      
      extraSlider.style.width = `${(extraCardWidth + extraMargin) * extraSlider.children.length}px`;
    }

    function updateExtraSlider() {
      const slideAmount = (extraCardWidth + extraMargin) * extraCurrentIndex;
      extraSlider.style.transform = `translateX(-${slideAmount}px)`;
      updateExtraDots();
    }

    const extraDotsContainer = document.querySelector('.extra-addon-dots');
    
    function initExtraDots() {
      extraDotsContainer.innerHTML = '';
      const slides = extraSlider.children;
      const cardsPerView = 3;
      const slideStep = 2;
      const maxIndex = slides.length - cardsPerView;
      const dotCount = Math.ceil((maxIndex + 1) / slideStep);
      
      for (let i = 0; i < dotCount; i++) {
        const dot = document.createElement('button');
        dot.className = 'extra-addon-dot' + (i === 0 ? ' active' : '');
        dot.addEventListener('click', () => {
          extraCurrentIndex = i * slideStep;
          updateExtraSlider();
        });
        extraDotsContainer.appendChild(dot);
      }
      updateExtraDots();
    }

    function updateExtraDots() {
      const slideStep = 2;
      const activeDotIndex = Math.floor(extraCurrentIndex / slideStep);
      const dots = document.querySelectorAll('.extra-addon-dot');
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === activeDotIndex);
      });
    }

    calculateExtraCardsPerView();
    updateExtraSlider();
    initExtraDots();

    extraPrevButton.addEventListener('click', () => {
      extraCurrentIndex = Math.max(extraCurrentIndex - 2, 0);
      updateExtraSlider();
    });

    extraNextButton.addEventListener('click', () => {
      const maxIndex = extraSlider.children.length - 3;
      extraCurrentIndex = Math.min(extraCurrentIndex + 2, maxIndex);
      updateExtraSlider();
    });

    window.addEventListener('resize', () => {
      calculateExtraCardsPerView();
      initExtraDots();
      updateExtraSlider();
    });
  }
}
function initializeAddons() {
  // Check if we're in a modal
  const isModal = document.querySelector('.quick-add-modal') !== null;
  
  // Initialize addons only if elements exist
  const quantityInputs = document.querySelectorAll('.addon-quantity .quantity__input');
  if (quantityInputs.length > 0) {
    quantityInputs.forEach(input => {
      const minusButton = input.previousElementSibling;
      const plusButton = input.nextElementSibling;

      minusButton?.addEventListener('click', (e) => handleQuantityChange(e, input, -1));
      plusButton?.addEventListener('click', (e) => handleQuantityChange(e, input, 1));
      input?.addEventListener('change', () => handleQuantityChange(null, input));
    });
  }

}
function initializeExtraAddons() {
  const isModal = document.querySelector('.quick-add-modal') !== null;
  
  // Initialize extra addon quantity inputs
  const quantityInputs = document.querySelectorAll('.extra-addon-quantity .extra-addon-quantity__input');
  if (quantityInputs.length > 0) {
    quantityInputs.forEach(input => {
      const minusButton = input.previousElementSibling;
      const plusButton = input.nextElementSibling;

      minusButton?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        input.value = Math.max(1, input.value - 1);
        updateExtraAddonQuantity(input);
      });

      plusButton?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        input.value = parseInt(input.value) + 1;
        updateExtraAddonQuantity(input);
      });

      input?.addEventListener('change', function() {
        this.value = Math.max(1, this.value);
        updateExtraAddonQuantity(this);
      });
    });
  }

  // Initialize extra addon checkboxes and selection
  const productCards = document.querySelectorAll('.extra-addon-product-card');
  productCards.forEach(card => {
    const checkbox = card.querySelector('.extra-addon-checkbox');
    const selectButton = card.querySelector('.extra-addon-select-button');
    const minusButton = card.querySelector('.extra-addon-quantity__button[name="minus"]');
    const plusButton = card.querySelector('.extra-addon-quantity__button[name="plus"]');
    const quantityInput = card.querySelector('.extra-addon-quantity__input');

    if (selectButton) {
      selectButton.addEventListener('click', (e) => {
        e.stopPropagation();
        checkbox.checked = !checkbox.checked;
        checkbox.dispatchEvent(new Event('change'));
        updateExtraAddonQuantity(quantityInput);
        
        if (checkbox.checked) {
          selectButton.style.display = 'none';
          minusButton.style.display = 'inline-block';
          plusButton.style.display = 'inline-block';
          quantityInput.style.display = 'inline-block';
        } else {
          selectButton.style.display = 'inline-block';
          minusButton.style.display = 'none';
          plusButton.style.display = 'none';
          quantityInput.style.display = 'none';
        }
      });
    }

    card.addEventListener('click', (e) => {
      if (e.target.closest('.extra-addon-quantity')) return;
      if (selectButton) selectButton.click();
    });
  });

  // Initialize extra addon checkboxes
  const checkboxes = document.querySelectorAll('.extra-addon-checkbox');
  checkboxes.forEach(checkbox => {
    const checkmark = checkbox.nextElementSibling?.querySelector('.extra-addon-checkmark');
    const quantityInput = checkbox.closest('.extra-addon-product-card')?.querySelector('.extra-addon-quantity__input');
    
    checkbox.addEventListener('change', function() {
      if (checkmark) {
        checkmark.classList.toggle('checked', this.checked);
      }
      const addonId = this.dataset.extraAddonId;
      const quantity = parseInt(quantityInput?.value || 1);
      toggleExtraAddon(addonId, this.checked ? quantity : 0);
    });
  });
}
function handleExtraQuantityChange(e, input, change) {
  if (e && e.preventDefault) e.preventDefault();
  if (input) {
    const value = parseInt(input.value) + change;
    input.value = Math.max(1, value);
    updateExtraAddonQuantity(input);
  }
}

function updateExtraAddonQuantity(input) {
  const checkbox = input.closest('.extra-addon-product-card').querySelector('.extra-addon-checkbox');
  if (checkbox?.checked) {
    const addonId = checkbox.dataset.extraAddonId;
    toggleExtraAddon(addonId, parseInt(input.value));
  }
}

function toggleExtraAddon(addonId, quantity = 1) {
  const index = window.selectedExtraAddons.findIndex(item => item.id === addonId);
  if (index > -1) {
    if (quantity > 0) {
      window.selectedExtraAddons[index].quantity = quantity;
    } else {
      window.selectedExtraAddons.splice(index, 1);
    }
  } else if (quantity > 0) {
    window.selectedExtraAddons.push({ 
      id: addonId, 
      quantity: quantity,
      properties: {
        '_is_extra_addon': 'true',
        '_source_product': '{{ product.id }}'
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  document.body.style.overflow = 'auto';
});
     
class ExtraAddon {
  constructor(element, quantityInput) {
    this.id = element.dataset.extraAddonId;
    this.quantity = parseInt(quantityInput?.value || 1);
  }

  static fromElement(element, quantityInput) {
    return new ExtraAddon(element, quantityInput);
  }
}



